/* eslint-disable*/
import React from "react";
import SystemMaintenanceMasterManagement_VoidReasonSetup from "./VoidReasonSetup";
import { screen, cleanup } from "@testing-library/react";
import "regenerator-runtime/runtime";
import userEvent from "@testing-library/user-event";
import { act } from "react-dom/test-utils";
import axios from "axios";
import renderTestScreen from "../../../../common/renderTestScreen";
import { t } from "../../../../__mocks__/react-i18next";

describe("VoidReasonSetup Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceMasterManagement_VoidReasonSetup />);
    });
  });
  afterEach(cleanup);
  test("is VoidReasonSetup Loads Successfully", () => {
    expect(screen.getByText("VoidReasonSetup")).toBeInTheDocument;
  });
  test("Custom Test Cases for VoidReasonSetup", () => {
    // START_USER_CODE-USER_VoidReasonSetup_Custom_Test_Case
    // END_USER_CODE-USER_VoidReasonSetup_Custom_Test_Case
  });
});
describe("Widget Test Cases", () => {
  beforeEach(async () => {
    act(() => {
      renderTestScreen(<SystemMaintenanceMasterManagement_VoidReasonSetup />);
    });
  });
  afterEach(cleanup);
  test("btnAdd(Button Widget) Test Cases", async () => {
    const btnAdd = screen.getByTestId("btnAdd");
    expect(btnAdd).toBeInTheDocument;
    expect(btnAdd.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:VoidReasonSetup_btnAdd")
    );
  });
  test("Custom Test Cases for btnAdd", () => {
    // START_USER_CODE-USER_btnAdd_TEST
    // END_USER_CODE-USER_btnAdd_TEST
  });
  test("btnClose(Button Widget) Test Cases", async () => {
    const btnClose = screen.getByTestId("btnClose");
    expect(btnClose).toBeInTheDocument;
    expect(btnClose.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:VoidReasonSetup_btnClose")
    );
  });
  test("Custom Test Cases for btnClose", () => {
    // START_USER_CODE-USER_btnClose_TEST
    // END_USER_CODE-USER_btnClose_TEST
  });
  test("btncmdEnableDisableControls(Button Widget) Test Cases", async () => {
    const btncmdEnableDisableControls = screen.getByTestId(
      "btncmdEnableDisableControls"
    );
    expect(btncmdEnableDisableControls).toBeInTheDocument;
    expect(btncmdEnableDisableControls.textContent).toEqual(
      t(
        "SystemMaintenanceMasterManagement:VoidReasonSetup_btncmdEnableDisableControls"
      )
    );
  });
  test("Custom Test Cases for btncmdEnableDisableControls", () => {
    // START_USER_CODE-USER_btncmdEnableDisableControls_TEST
    // END_USER_CODE-USER_btncmdEnableDisableControls_TEST
  });
  test("btnDelete(Button Widget) Test Cases", async () => {
    const btnDelete = screen.getByTestId("btnDelete");
    expect(btnDelete).toBeInTheDocument;
    expect(btnDelete.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:VoidReasonSetup_btnDelete")
    );
  });
  test("Custom Test Cases for btnDelete", () => {
    // START_USER_CODE-USER_btnDelete_TEST
    // END_USER_CODE-USER_btnDelete_TEST
  });
  test("btnEdit(Button Widget) Test Cases", async () => {
    const btnEdit = screen.getByTestId("btnEdit");
    expect(btnEdit).toBeInTheDocument;
    expect(btnEdit.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:VoidReasonSetup_btnEdit")
    );
  });
  test("Custom Test Cases for btnEdit", () => {
    // START_USER_CODE-USER_btnEdit_TEST
    // END_USER_CODE-USER_btnEdit_TEST
  });
  test("gridVoidReasonData(Grid Widget) Test Cases", async () => {
    let gridVoidReasonData = screen.getByTestId("gridVoidReasonData");
    let gridVoidReasonDatabtn =
      gridVoidReasonData.nextElementSibling.firstElementChild;
    gridVoidReasonData =
      gridVoidReasonData.parentElement.parentElement.parentElement;
    expect(gridVoidReasonData.tagName).toBe("DIV");
    expect(gridVoidReasonData.classList).toContain("GridWidget");
    expect(
      screen.getAllByText(
        t(
          "SystemMaintenanceMasterManagement:VoidReasonSetup_gridVoidReasonData"
        )
      )
    ).toBeInTheDocument;
  });
  test("Custom Test Cases for gridVoidReasonData", () => {
    // START_USER_CODE-USER_gridVoidReasonData_TEST
    // END_USER_CODE-USER_gridVoidReasonData_TEST
  });
  test("grpbxVoidReasonSetup(GroupBox Widget) Test Cases", async () => {
    const grpbxVoidReasonSetup = screen.getByTestId("grpbxVoidReasonSetup");
    expect(grpbxVoidReasonSetup.tagName).toBe("BUTTON");
    expect(grpbxVoidReasonSetup.type).toBe("button");
    expect(grpbxVoidReasonSetup.classList).toContain("btn");
  });
  test("Custom Test Cases for grpbxVoidReasonSetup", () => {
    // START_USER_CODE-USER_grpbxVoidReasonSetup_TEST
    // END_USER_CODE-USER_grpbxVoidReasonSetup_TEST
  });
  test("lblVoidReason(Label Widget) Test Cases", async () => {
    const lblVoidReason = screen.getByTestId("lblVoidReason");
    expect(lblVoidReason.tagName).toBe("LABEL");
    expect(lblVoidReason.classList).toContain("form-label");
    expect(lblVoidReason.textContent).toEqual(
      t("SystemMaintenanceMasterManagement:VoidReasonSetup_lblVoidReason")
    );
  });
  test("Custom Test Cases for lblVoidReason", () => {
    // START_USER_CODE-USER_lblVoidReason_TEST
    // END_USER_CODE-USER_lblVoidReason_TEST
  });
  test("gridVoidReasonData_txtAction(Grid Widget) Test Cases", async () => {
    let gridVoidReasonData_txtAction = screen.getByTestId("gridVoidReasonData");
    let gridVoidReasonData_txtActionbtn =
      gridVoidReasonData_txtAction.nextElementSibling.firstElementChild;
    gridVoidReasonData_txtAction =
      gridVoidReasonData_txtAction.parentElement.parentElement.parentElement;
    expect(gridVoidReasonData_txtAction.tagName).toBe("DIV");
    expect(gridVoidReasonData_txtAction.classList).toContain("GridWidget");
    expect(
      screen.getAllByText(
        t(
          "SystemMaintenanceMasterManagement:VoidReasonSetup_gridVoidReasonData"
        )
      )
    ).toBeInTheDocument;
  });
  test("Custom Test Cases for txtAction", () => {
    // START_USER_CODE-USER_txtAction_TEST
    // END_USER_CODE-USER_txtAction_TEST
  });
  test("gridVoidReasonData_txtCode(Grid Widget) Test Cases", async () => {
    let gridVoidReasonData_txtCode = screen.getByTestId("gridVoidReasonData");
    let gridVoidReasonData_txtCodebtn =
      gridVoidReasonData_txtCode.nextElementSibling.firstElementChild;
    gridVoidReasonData_txtCode =
      gridVoidReasonData_txtCode.parentElement.parentElement.parentElement;
    expect(gridVoidReasonData_txtCode.tagName).toBe("DIV");
    expect(gridVoidReasonData_txtCode.classList).toContain("GridWidget");
    expect(
      screen.getAllByText(
        t(
          "SystemMaintenanceMasterManagement:VoidReasonSetup_gridVoidReasonData"
        )
      )
    ).toBeInTheDocument;
  });
  test("Custom Test Cases for txtCode", () => {
    // START_USER_CODE-USER_txtCode_TEST
    // END_USER_CODE-USER_txtCode_TEST
  });
  test("gridVoidReasonData_txtDescription(Grid Widget) Test Cases", async () => {
    let gridVoidReasonData_txtDescription = screen.getByTestId(
      "gridVoidReasonData"
    );
    let gridVoidReasonData_txtDescriptionbtn =
      gridVoidReasonData_txtDescription.nextElementSibling.firstElementChild;
    gridVoidReasonData_txtDescription =
      gridVoidReasonData_txtDescription.parentElement.parentElement
        .parentElement;
    expect(gridVoidReasonData_txtDescription.tagName).toBe("DIV");
    expect(gridVoidReasonData_txtDescription.classList).toContain("GridWidget");
    expect(
      screen.getAllByText(
        t(
          "SystemMaintenanceMasterManagement:VoidReasonSetup_gridVoidReasonData"
        )
      )
    ).toBeInTheDocument;
  });
  test("Custom Test Cases for txtDescription", () => {
    // START_USER_CODE-USER_txtDescription_TEST
    // END_USER_CODE-USER_txtDescription_TEST
  });
  test("gridVoidReasonData_txtLimitedAccess(Grid Widget) Test Cases", async () => {
    let gridVoidReasonData_txtLimitedAccess = screen.getByTestId(
      "gridVoidReasonData"
    );
    let gridVoidReasonData_txtLimitedAccessbtn =
      gridVoidReasonData_txtLimitedAccess.nextElementSibling.firstElementChild;
    gridVoidReasonData_txtLimitedAccess =
      gridVoidReasonData_txtLimitedAccess.parentElement.parentElement
        .parentElement;
    expect(gridVoidReasonData_txtLimitedAccess.tagName).toBe("DIV");
    expect(gridVoidReasonData_txtLimitedAccess.classList).toContain(
      "GridWidget"
    );
    expect(
      screen.getAllByText(
        t(
          "SystemMaintenanceMasterManagement:VoidReasonSetup_gridVoidReasonData"
        )
      )
    ).toBeInTheDocument;
  });
  test("Custom Test Cases for txtLimitedAccess", () => {
    // START_USER_CODE-USER_txtLimitedAccess_TEST
    // END_USER_CODE-USER_txtLimitedAccess_TEST
  });
  test("gridVoidReasonData_txtTranslateCode(Grid Widget) Test Cases", async () => {
    let gridVoidReasonData_txtTranslateCode = screen.getByTestId(
      "gridVoidReasonData"
    );
    let gridVoidReasonData_txtTranslateCodebtn =
      gridVoidReasonData_txtTranslateCode.nextElementSibling.firstElementChild;
    gridVoidReasonData_txtTranslateCode =
      gridVoidReasonData_txtTranslateCode.parentElement.parentElement
        .parentElement;
    expect(gridVoidReasonData_txtTranslateCode.tagName).toBe("DIV");
    expect(gridVoidReasonData_txtTranslateCode.classList).toContain(
      "GridWidget"
    );
    expect(
      screen.getAllByText(
        t(
          "SystemMaintenanceMasterManagement:VoidReasonSetup_gridVoidReasonData"
        )
      )
    ).toBeInTheDocument;
  });
  test("Custom Test Cases for txtTranslateCode", () => {
    // START_USER_CODE-USER_txtTranslateCode_TEST
    // END_USER_CODE-USER_txtTranslateCode_TEST
  });
});
